import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import SvgIcon from './SvgIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Zoom brand mark — a video camera in Zoom blue. The fill is set per-path so
// `currentColor` on the wrapping svg does not affect it.
var Zoom = function Zoom(props) {
  return /*#__PURE__*/_jsxs(SvgIcon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#2D8CFF",
      d: "M3 8.5A2.5 2.5 0 0 1 5.5 6h8A2.5 2.5 0 0 1 16 8.5v7A2.5 2.5 0 0 1 13.5 18h-8A2.5 2.5 0 0 1 3 15.5z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#2D8CFF",
      d: "M17.5 10.2l3.2-2.3c.66-.48 1.6-.02 1.6.8v6.6c0 .82-.94 1.28-1.6.8l-3.2-2.3z"
    })]
  }));
};
export default Zoom;